import React, {PureComponent} from 'react';
import {withRouter} from 'react-router-dom';
import {Button} from 'components';
import ReactMarkdown from 'react-markdown';
import masthead from './masthead.md';

import styles from './styles';

class Features extends PureComponent {

  handleGetStartedClick = () => {
    const { history, linkLocation } = this.props;

    history.push(linkLocation || '/');
  };

  render() {
    const {customMasthead} = this.props;

    return (
      <div>
        <div className={`${styles.masthead} container`}>
          <ReactMarkdown source={customMasthead || masthead} />
          <Button className='accent-button' onClick={this.handleGetStartedClick}>
            {'Get Started'}
          </Button>
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default withRouter(Features);



// WEBPACK FOOTER //
// ./src/containers/Features/index.jsx